import { MatchListStoreModel } from '../../utils/match-list-models';
import { AppAction } from '@om-fe/store';
import { DisciplineLiveStatus } from '@om-fe/models';

export const PARTICIPANT_MATCH_AGGREGATOR_PATH: string = 'participant-aggregator-main/:participantId/default-event-info/:liveStatus/:nrOfMarkets';
export const PARTICIPANT_MATCH_AGGREGATOR_PATH_LOGGED_IN: string = 'participant-aggregator-main/:participantId/default-event-info/logged-in-users/:liveStatus/:nrOfMarkets';

export const slicePrefix = 'participant';

export interface ParticipantMatchListStoreModel extends MatchListStoreModel {
    readonly ready: boolean;
    readonly isLoadingMoreData: boolean;
    readonly isLoadingData: boolean;
    readonly participantId?: string;
    readonly mainMarketsLimit?: number;
    readonly liveStatus?: DisciplineLiveStatus;
    readonly limit: number;
    readonly totalRecords: number;
}

export enum ParticipantMatchListActions {
    SetLoadingData = 'sports:participant-match-list:set-loading-data',
    SetFilterData = 'sports:participant-match-list:set-match-list-filter-data',
}

export interface ParticipantMatchListSetLoadingData extends AppAction<ParticipantMatchListActions.SetLoadingData> {
    readonly type: ParticipantMatchListActions;
    readonly meta: {
        readonly slice: string;
    };
    readonly payload: {
        readonly isLoadingMoreData: boolean;
    };
}

export interface ParticipantMatchListSetFilterDataAction extends AppAction<ParticipantMatchListActions.SetFilterData> {
    readonly type: ParticipantMatchListActions;
    readonly meta: {
        readonly slice: string;
    };
    readonly payload: {
        readonly participantId: string;
        readonly liveStatus: DisciplineLiveStatus;
    };
}

export interface ParticipantMatchListTopic {
    readonly path: string;
    readonly params: {
        readonly participantId: string;
        readonly liveStatus?: DisciplineLiveStatus;
        readonly nrOfMarkets: number;
    };
}
